













































































import DownloadPreviewDialog from "@/components/DownloadPreviewDialog.vue";
import { SurveyStatusResult } from "@/interfaces";
import { AuthModule } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AmbitPlan extends Vue {
  @AuthModule.bindings.State
  dmpLink!: string;

  @AuthModule.bindings.State("loadingStatus")
  loading!: boolean;

  @AuthModule.bindings.State
  loadingDMP!: boolean;

  @AuthModule.bindings.State
  status!: SurveyStatusResult;

  menuDefault = [];

  get menu() {
    const menuItems = [];

    if (this.status) {
      if (this.status.has_user_strategy === null) {
        menuItems.push({
          title: "Riassunto strategia",
          statusLabel: "Da compilare",
          status: "pending",
          subtitle: "",
          to: "/strategy-summary",
        });
      } else {
        menuItems.push({
          title: "Riassunto strategia",
          statusLabel: "Compilato",
          status: "completed",
          subtitle: "",
          to: "/strategy-summary",
        });
      }

      if (this.status.last_dmp) {
        menuItems.push({
          title: "Scarica Piano Compilato",
          subtitle: "",
          to: this.status.last_dmp,
          type: "link",
        });
      } else {
        menuItems.push({
          title: "Visualizza anteprima Piano",
          subtitle: "",
          click: this.onPreviewClick,
        });
      }
    }

    return [...this.menuDefault, ...menuItems];
  }

  async onPreviewClick() {
    try {
      await AuthModule.store.getDMP();

      this.$q.dialog({
        component: DownloadPreviewDialog,
        parent: this,
        title: "Anteprima Piano operativo pronta",
        link: this.dmpLink,
      });
    } catch (error) {
      console.log(error);
    }
  }

  onSurveyTypeClick(to: string, type = "") {
    if (type !== "link") {
      this.$router.push(to).catch(error => console.log(error));
    } else {
      window.open(to, "_blank");
    }
  }
}
